import { z } from 'zod';

export const PUBLIC_API_TOKEN_NAME_MAX = 100;
export const PUBLIC_API_TOKEN_DESCRIPTION_MAX = 500;

export const PublicApiTokenListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  tokenPrefix: z.string(),
  lastUsedAt: z.string().nullable(),
  createdAt: z.string(),
});

export const PublicApiTokenCreateBodySchema = z.object({
  name: z.string().trim().min(1, 'name is required').max(PUBLIC_API_TOKEN_NAME_MAX),
  description: z
    .string()
    .trim()
    .max(PUBLIC_API_TOKEN_DESCRIPTION_MAX)
    .optional()
    .transform((v) => (v === '' ? undefined : v)),
});

export const PublicApiTokenCreateResponseSchema = PublicApiTokenListItemSchema.extend({
  token: z.string(),
});

export const PublicApiTokenUpdateBodySchema = z
  .object({
    name: z.string().trim().min(1).max(PUBLIC_API_TOKEN_NAME_MAX).optional(),
    description: z
      .string()
      .trim()
      .max(PUBLIC_API_TOKEN_DESCRIPTION_MAX)
      .nullable()
      .optional(),
  })
  .refine((body) => body.name !== undefined || body.description !== undefined, {
    message: 'At least one of name or description is required',
  });

export const PublicApiTokenIdParamsSchema = z.object({
  id: z.string().min(1),
});

export type PublicApiTokenListItem = z.infer<typeof PublicApiTokenListItemSchema>;
export type PublicApiTokenCreateBody = z.infer<typeof PublicApiTokenCreateBodySchema>;
export type PublicApiTokenCreateResponse = z.infer<typeof PublicApiTokenCreateResponseSchema>;
export type PublicApiTokenUpdateBody = z.infer<typeof PublicApiTokenUpdateBodySchema>;
